import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { FeatureSpecEffects } from './entity/feature-spec.effects';
import {
  FeatureSpecNamespace,
  FeatureSpecReducer,
  FeatureSpecStoreToken,
} from './entity/feature-spec.store';

@NgModule({
  imports: [
    EffectsModule.forFeature([FeatureSpecEffects]),
    StoreModule.forFeature(FeatureSpecNamespace, FeatureSpecReducer, FeatureSpecStoreToken),
  ],
})
export class FeatureSpecDataModule {}
